
export const PARTICIPANT_STATES = {
	REMOTE: 0,
	PRESENT: 1,
	REPRESENTATED: 2,
	DELEGATED: 4,
	PHYSICALLY_PRESENT: 5,
	NO_PARTICIPATE: 6,
	PRESENT_WITH_REMOTE_VOTE: 7,
	SENT_VOTE_LETTER: 8,
	REMOTE_VOTE: 9,
	PRESENT_VOTE: 10,
	LEFT: 11,
	EARLY_VOTE: 12
};

export const AGENDA_TYPES = {
	INFORMATIVE: 0,
	PUBLIC_VOTING: 1,
	PUBLIC_ACT: 2,
	FAKE_PUBLIC_VOTING: 3,
	PRIVATE_ACT: 4,
	PRIVATE_VOTING: 5,
	CUSTOM_PUBLIC: 8,
	CUSTOM_PRIVATE: 7,
	CUSTOM_NOMINAL: 6,
	CONFIRMATION_REQUEST: 9
};

// CONTINUATION OF AGENDA_TYPES
export const CUSTOM_AGENDA_VOTING_TYPES = [
	{
		label: 'public_voting',
		value: 6
	},
	{
		label: 'private_voting',
		value: 7
	},
	{
		label: 'fake_public_votation',
		value: 8
	}
];

export const MAX_FILE_SIZE = 20000; // in KB


export const PARTICIPANT_TYPE = {
	PARTICIPANT: 0,
	GUEST: 1,
	REPRESENTATIVE: 2,
	REPRESENTATED: 3
};

export const VOTE_VALUES = {
	VOTED: -2,
	NO_VOTE: -1,
	NEGATIVE: 0,
	POSITIVE: 1,
	ABSTENTION: 2
};

export const FORM_DATA = {
	councilId: '',
	personOrEntity: 0, // If it is a physical person (0) or a legal entity (1)
	name: '',
	surname: '',
	email: '',
	dni: '',
	phone: '',
	initialState: '',
	socialCapital: undefined, // Number of shares owned
	numParticipations: undefined, // Number of shares owned
	position: undefined, // Unique code
	language: 'es', // Prefered language for when getting into the platform
	votes: [], // Anticipated votes
	votesIsActive: false,
	followAssembly: false,
	requestType: '', // access, represent, vote, representation
	representative: { // If personOrEntity === 1, we need a representative
		name: '',
		surname: '',
		dni: '',
		email: '',
		phone: '',
		language: 'es',
	},
	delegate: {
		name: '',
		surname: '',
		dni: '',
		email: '',
		phone: '',
	},
	intervention: '',
	attachments: {},
};

/*
[{
	base64: "/9j/4AAQSkZJRgABAQEAWgBaAAD/2wBDAAMCAgMCAgMDAwMEA
	filename: "Prueba"
	filesize: 16665
	filetype: "image/jpeg"
},]

[{
	"id": 15483,
	"value": 2961
},]
*/

export const FONT_SIZE = {
	xxs: '0.50rem',
	xs: '0.75rem',
	sm: '0.875rem',
	base: '1rem',
	lg: '1.125rem',
	xl: '1.25rem',
	'2xl': '1.5rem',
	'3xl': '1.875rem',
	'4xl': '2.25rem',
	'5xl': '3rem',
	'6xl': '3.75rem',
	'7xl': '4.5rem',
	'8xl': '6rem',
	'9xl': '8rem',
};

export const WINDOW_SIZE = {
	/* width in px */
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	'2xl': 1536,
};

export const COLORS = {
	primary: '#154481',
	secondary: '#ffffff',
	light: '#e8ecf2',
	dark: '#0b2241',
	background: '#FFFFFF',
	text: '#154481',
	success: '#61B78A',
	warning: '#F4AB66',
	error: '#DC7575',
	deactivated: '#B4B4B4',
};

export const LIGHT_COLOR_FACTOR = 0.90;
export const DARK_COLOR_FACTOR = 0.50;

// https://gist.github.com/lopspower/03fb1cc0ac9f32ef38f4
export const HEX_ALPHA = {
	100: 'FF',
	99: 'FC',
	98: 'FA',
	97: 'F7',
	96: 'F5',
	95: 'F2',
	94: 'F0',
	93: 'ED',
	92: 'EB',
	91: 'E8',
	90: 'E6',
	89: 'E3',
	88: 'E0',
	87: 'DE',
	86: 'DB',
	85: 'D9',
	84: 'D6',
	83: 'D4',
	82: 'D1',
	81: 'CF',
	80: 'CC',
	79: 'C9',
	78: 'C7',
	77: 'C4',
	76: 'C2',
	75: 'BF',
	74: 'BD',
	73: 'BA',
	72: 'B8',
	71: 'B5',
	70: 'B3',
	69: 'B0',
	68: 'AD',
	67: 'AB',
	66: 'A8',
	65: 'A6',
	64: 'A3',
	63: 'A1',
	62: '9E',
	61: '9C',
	60: '99',
	59: '96',
	58: '94',
	57: '91',
	56: '8F',
	55: '8C',
	54: '8A',
	53: '87',
	52: '85',
	51: '82',
	50: '80',
	49: '7D',
	48: '7A',
	47: '78',
	46: '75',
	45: '73',
	44: '70',
	43: '6E',
	42: '6B',
	41: '69',
	40: '66',
	39: '63',
	38: '61',
	37: '5E',
	36: '5C',
	35: '59',
	34: '57',
	33: '54',
	32: '52',
	31: '4F',
	30: '4D',
	29: '4A',
	28: '47',
	27: '45',
	26: '42',
	25: '40',
	24: '3D',
	23: '3B',
	22: '38',
	21: '36',
	20: '33',
	19: '30',
	18: '2E',
	17: '2B',
	16: '29',
	15: '26',
	14: '24',
	13: '21',
	12: '1F',
	11: '1C',
	10: '1A',
	9: '17',
	8: '14',
	7: '12',
	6: '0F',
	5: '0D',
	4: '0A',
	3: '08',
	2: '05',
	1: '03',
	0: '00',
};

export const SHAREHOLDER_DATA = ['name', 'surname', 'email', 'dni', 'phone', 'initialState', 'socialCapital', 'numParticipations', 'position', 'language'];


/* Custom agendas have an aditional Abstention item that is special since
*  If choosen o a multiple option agenda it overrides options.minSelections
*  and will empty the chosen values array
*/
export const CUSTOM_ABSTENTION_AGENDAS = {
	value: VOTE_VALUES.ABSTENTION,
	text: '',
	label: 'abstention',
};

export const DEFAULT_ITEMS_AGENDA = [
	{
		value: VOTE_VALUES.POSITIVE,
		text: '',
		label: 'yes'
	},
	{
		value: VOTE_VALUES.NEGATIVE,
		text: '',
		label: 'no'
	},
	{
		value: VOTE_VALUES.ABSTENTION,
		text: '',
		label: 'abstention'
	}
];

export const CONFIRMATION_ITEMS_AGENDA = [
	{
		value: VOTE_VALUES.POSITIVE,
		text: '',
		label: 'yes'
	},
	{
		value: VOTE_VALUES.NEGATIVE,
		text: '',
		label: 'no'
	}
];

/* Agenda blocks */
export const INFORMATIVE_AGENDAS = AGENDA_TYPES.INFORMATIVE;
export const DEFAULT_AGENDAS = [AGENDA_TYPES.PUBLIC_VOTING, AGENDA_TYPES.PUBLIC_ACT,
	AGENDA_TYPES.FAKE_PUBLIC_VOTING, AGENDA_TYPES.PRIVATE_ACT, AGENDA_TYPES.PRIVATE_VOTING];
export const CUSTOM_AGENDAS = [AGENDA_TYPES.CUSTOM_NOMINAL, AGENDA_TYPES.CUSTOM_PRIVATE, AGENDA_TYPES.CUSTOM_PUBLIC];
export const CONFIRMATION_AGENDAS = [AGENDA_TYPES.CONFIRMATION_REQUEST];

export const MAXINPUTLENGHT = 50;

export const LOADING_SCREEN = {
	mainImg: '',
	downImg: '',
	information: {
		label: '',
		text: {
			es: '<p style="text-align: center;"><em><strong>Est&aacute; siendo dirigido al portal de accionista.</strong></em></p><br/><p style="text-align: center;"><strong><em>No cierre el navegador</em></strong></p>',
			en: '<p style="text-align: center;"><em><strong>You are being directed to the shareholder portal.</strong></em></p><br/><p style="text-align: center;"><strong><em>Don&apos;t close the browser</em></strong></p>',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
	},
};

export const NOT_FOUND = {
	img: 'https://api.dev.councilbox.com/static/img/notFound.png',
	information: {
		label: '',
		text: {
			es: '<p style="text-align: center;"><strong>&iexcl;Vaya! No hay manera de encontrar esa p&aacute;gina.</strong></p><br/><p style="text-align: center;">Por favor revise que la url est&aacute; bien escrita o navegue por las opciones del men&uacute;.</p>',
			en: '<p style="text-align: center;"><strong>Wow! There is no way to find that page.</strong></p><br/><p style="text-align: center;">Please check that the url is well written or browse through the menu options.</p>',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: '',
		},
	},
};

export const OTHER_PERSON = {
	label: 'Otra persona', // TRADUCCION
	text: {
		es: 'Otra persona',
		en: 'Another person',
	},
	value: '',
};

export const FORM_SECTIONS = ['access', 'representation', 'delegation', 'earlyVote', 'interventions'];

export const ALL_SECTIONS = ['home', ...FORM_SECTIONS, 'documents'];
